// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
// Pinned to bd8cb85bd4bad964fe6918f79665bb40c3a8efef.
import { MaterialSymbol, type MaterialIconProps } from './material-symbol';
const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M216-96q-29.7 0-50.85-21.15Q144-138.3 144-168v-412q-21-8-34.5-26.5T96-648v-144q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v144q0 23-13.5 41.5T816-580v411.86Q816-138 794.85-117T744-96H216Zm0-480v408h528v-408H216Zm-48-72h624v-144H168v144Zm252 240h120q15.3 0 25.65-10.29Q576-428.58 576-443.79t-10.35-25.71Q555.3-480 540-480H420q-15.3 0-25.65 10.29Q384-459.42 384-444.21t10.35 25.71Q404.7-408 420-408Zm60 36Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M200-80q-33 0-56.5-23.5T120-160v-451q-18-11-29-28.5T80-680v-120q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v120q0 23-11 40.5T840-611v451q0 33-23.5 56.5T760-80H200Zm0-520v440h560v-440H200Zm-40-80h640v-120H160v120Zm240 280h160q17 0 28.5-11.5T600-440q0-17-11.5-28.5T560-480H400q-17 0-28.5 11.5T360-440q0 17 11.5 28.5T400-400Zm80 20Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M216-96q-29.7 0-50.85-21.15Q144-138.3 144-168v-412q-21-8-34.5-26.5T96-648v-144q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v144q0 23-13.5 41.5T816-580v411.86Q816-138 794.85-117T744-96H216Zm-48-552h624v-144H168v144Zm252 240h120q15.3 0 25.65-10.29Q576-428.58 576-443.79t-10.35-25.71Q555.3-480 540-480H420q-15.3 0-25.65 10.29Q384-459.42 384-444.21t10.35 25.71Q404.7-408 420-408Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M200-80q-33 0-56.5-23.5T120-160v-451q-18-11-29-28.5T80-680v-120q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v120q0 23-11 40.5T840-611v451q0 33-23.5 56.5T760-80H200Zm-40-600h640v-120H160v120Zm240 280h160q17 0 28.5-11.5T600-440q0-17-11.5-28.5T560-480H400q-17 0-28.5 11.5T360-440q0 17 11.5 28.5T400-400Z"
    ]
  }
} as const;
export function Inventory2Icon(props: MaterialIconProps) { return <MaterialSymbol {...props} symbol="inventory_2" artwork={artwork} />; }
